import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, Route } from 'react-router-dom'
import { Grid, withStyles } from '@material-ui/core'

import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { fetchSupplier } from '../SupplierActions'

import styles from '../../../resources/theme/global'
import Filter from './Filter'
import List from './List'
import New from './New'
import Edit from './Edit'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

const Supplier = props => {
  const dispatch = useDispatch()
  const location = useLocation()

  const filters = useQueryParams(location.search)

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead, canUpdate } = usePermissions()

  const { classes } = props

  useEffect(() => {
    dispatch(fetchSupplier(filters, filters?.rows || 10, filters?.page || 1))
  }, [location])

  return (
    <BaseCreatePage
      page="Financeiro"
      path="Contatos"
      pageLink="/supplier"
      hiddenReturn
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Filter />
        </Grid>

        {canRead('contatos-financeiros', permissionUser) && (
          <Grid item xs={12}>
            <List classes={classes} />
          </Grid>
        )}
      </Grid>

      {canCreate('contatos-financeiros', permissionUser) && (
        <Route path="/supplier/new" component={New} />
      )}

      {canUpdate('contatos-financeiros', permissionUser) && (
        <Route path="/supplier/:id/edit" component={Edit} />
      )}
    </BaseCreatePage>
  )
}

export default withStyles(styles)(Supplier)
